import {
  fetchBreaksData,
  fetchCycles,
  fetchFlowData,
  fetchOpsClockData,
  fetchSettingsInsight,
  fetchTriggerConfigurationsData,
  updateBreaks,
  updateDefaultClockConfiguration,
  updateFlowData,
  updateOpsClock,
} from "./SettingsNetworkAPI";
import {
  CURR_FIXED_HC_TIME_INTERVALS_MIN_ASSOCIATES,
  CYCLE,
  FIXED_HC_TIME_INTERVALS_MIN_ASSOCIATES,
  INDIRECT_HC_FIELD_NAME_ASSOCIATED_PROCESS,
  INDIRECT_HC_FIELD_NAME_RATE,
  INDIRECT_HC_RULE_TYPE_FIXED_HC,
  INDIRECT_HC_RULE_TYPE_RATIO,
  INDIRECT_HC_RULE_TYPE_VOLUME,
  MODAL_SUCCESS,
  PROCESS,
} from "./SettingsConstant";
import { getStationCode } from "../../network/NetworkUtil";

export const SettingsReducer = (state, action) => {
  switch (action.type) {
    case "LOAD_FLOW_DATA":
      const dispatcher = action.data.dispatcher;
      fetchFlowData("station-target", dispatcher);
      return state;

    case "RECEIVE_FLOW_DATA":
      if (
        action.data &&
        Object.keys(action.data).length > 0 &&
        action.data[0].targetMap
      ) {
        return {
          ...state,
          settingsData: {
            ...state.settingsData,
            flowData: {
              ...state.settingsData.flowData,
              ...action.data[0].targetMap,
            },
          },
        };
      }
      return state;

    case "UPDATE_FLOW_DATA":
      updateFlowData(action.data.dispatcher, action.data.flowData);
      return state;

    case "UPDATE_FLOW_RESPONSE":
      return {
        ...state,
        settingsData: {
          ...state.settingsData,
          flowData: {
            ...state.settingsData.flowData,
            ...action.data.targetMap,
          },
        },
      };

    case "RECEIVE_INDIRECT_HC_DATA":
      return {
        ...state,
        settingsData: {
          ...state.settingsData,
          indirectHCData: action.data,
        },
      };

    case "SET_INDIRECT_HC_RULE":
      // action.data = {
      //     process : "",
      //     ruleType : "",
      //     volume : "",
      //     minAssociates : "",
      //     associatedProcess : "",
      //     ratioToAssociatedProcess : ""
      // }

      let isNewCycleEntry = false;
      let updatedIndirectHCData;

      const rule = {
        minAssociates: action.data["minAssociates"],
        ruleType: action.data["ruleType"],
      };
      if (action.data["ruleType"] === INDIRECT_HC_RULE_TYPE_FIXED_HC) {
        rule[INDIRECT_HC_FIELD_NAME_RATE] = action.data.rate;
        rule[INDIRECT_HC_FIELD_NAME_ASSOCIATED_PROCESS] =
          action.data.associatedProcess;
      }
      if (action.data["ruleType"] === INDIRECT_HC_RULE_TYPE_VOLUME) {
        rule["volume"] = action.data.volume;
      } else if (action.data["ruleType"] === INDIRECT_HC_RULE_TYPE_RATIO) {
        rule["associatedProcess"] = action.data.associatedProcess;
        rule["ratioToAssociatedProcess"] = action.data.ratioToAssociatedProcess;
      }
      if (
        action.data["ruleType"] === INDIRECT_HC_RULE_TYPE_FIXED_HC &&
        action.data[CURR_FIXED_HC_TIME_INTERVALS_MIN_ASSOCIATES]
      ) {
        rule[FIXED_HC_TIME_INTERVALS_MIN_ASSOCIATES] = JSON.parse(
          JSON.stringify(
            action.data[CURR_FIXED_HC_TIME_INTERVALS_MIN_ASSOCIATES],
          ),
        );
      }

      const currentCycle = action.data[CYCLE];
      const newIndirectHCData = [
        ...Array.from(state.settingsData.indirectHCData),
      ];
      const index = newIndirectHCData.findIndex(
        (obj) => obj[CYCLE] === currentCycle,
      );

      if (index === -1) {
        // Create new entry if cycleName not present
        isNewCycleEntry = true;
        const newEntry = {
          stationCode: getStationCode(),
          cycleName: currentCycle,
          processRules: {
            [action.data.process]: rule,
          },
        };
        newIndirectHCData.push(newEntry);
      } else {
        // Update existing entry if cycleName is present
        updatedIndirectHCData = Array.from(
          state.settingsData.indirectHCData,
        ).map((obj) => {
          if (obj[CYCLE] === action.data[CYCLE]) {
            const newProcessRules = {
              ...obj.processRules,
              [action.data.process]: rule,
            };
            return { ...obj, processRules: newProcessRules };
          }
          return obj;
        });
      }

      return {
        ...state,
        settingsData: {
          ...state.settingsData,
          indirectHCData: isNewCycleEntry
            ? newIndirectHCData
            : updatedIndirectHCData,
        },
      };

    case "DELETE_INDIRECT_HC_RULE":
      const ruleToDelete = action.data;
      const processToDelete = ruleToDelete[PROCESS];
      const cycleName = ruleToDelete[CYCLE];

      const filteredDataAfterDelete = Array.from(
        state.settingsData.indirectHCData,
      ).map((obj) => {
        if (obj[CYCLE] === cycleName) {
          const { [processToDelete]: _, ...newProcessRules } = obj.processRules;
          return { ...obj, processRules: newProcessRules };
        }
        return obj;
      });

      return {
        ...state,
        settingsData: {
          ...state.settingsData,
          indirectHCData: filteredDataAfterDelete,
        },
      };

    case "DELETE_FIXED_HC_TIME_INTERVAL":
      return {
        ...state,
      };

    case "OPEN_DELETE_INDIRECT_HC_RULE_MODAL":
      return {
        ...state,
        settingsData: {
          ...state.settingsData,
          openDeleteIndirectHCRuleModal: true,
          indirectHCRuleToDelete: action["data"],
        },
      };
    case "CLOSE_DELETE_INDIRECT_HC_RULE_MODAL":
      return {
        ...state,
        settingsData: {
          ...state.settingsData,
          openDeleteIndirectHCRuleModal: false,
        },
      };

    case "FETCH_CYCLE":
      fetchCycles(action.data.dispatcher);
      return state;

    case "RECEIVE_CYCLE":
      return { ...state, allCycles: action.data.cycles };

    case "LOAD_OPS_CLOCK_DATA":
      fetchOpsClockData(
        action.data.dispatcher,
        action.data.dispatchDate,
        action.data.actionType,
      );
      return state;

    case "OPS_CLOCK_DATA":
      return { ...state, ...action.data };

    case "LOAD_TRIGGER_CONFIGURATIONS":
      fetchTriggerConfigurationsData(action.data.dispatcher);
      return state;

    case "UPDATE_TRIGGER_CONFIGURATIONS":
      return { ...state, ...action.data };

    case "LOAD_BREAKS_DATA":
      fetchBreaksData(action.data.dispatcher, action.data.dispatchDate);
      return state;

    case "BREAKS_DATA":
      return { ...state, ...action.data };

    case "UPDATE_OPS_CLOCK_REQUEST":
      updateOpsClock(action.data.dispatcher, action.data.planData);
      return { ...state };

    case "UPDATE_BREAKS_REQUEST":
      updateBreaks(
        action.data.dispatcher,
        action.data.planData,
        action.data.showUpdateBreakModal,
      );
      return { ...state };

    case "UPDATE_DEFAULT_CLOCK_CONFIGURATION_REQUEST":
      updateDefaultClockConfiguration(
        action.data.dispatcher,
        action.data.defaultClockConfiguration,
      );
      return { ...state };

    case "UPDATE_DEFAULT_CLOCK_CONFIGURATION_RESPONSE":
      if (action.data.showUpdatePlanResponseModal === MODAL_SUCCESS) {
        fetchSettingsInsight(action.data.dispatcher);
      }
      return {
        ...state,
        showUpdatePlanResponseModal: action.data.showUpdatePlanResponseModal,
        messageToDisplay: action.data.message,
        opsClockData: {
          ...state.opsClockData,
          defaultClockConfiguration: {
            ...state.opsClockData.defaultClockConfiguration,
            ...action.data.defaultClockConfiguration,
          },
        },
      };

    case "UPDATE_PLAN_RESPONSE":
      return {
        ...state,
        showUpdatePlanResponseModal: action.data.showUpdatePlanResponseModal,
        messageToDisplay: action.data.message,
        opsClockData: action.data.opsClockData
          ? {
              opsClock: action.data.opsClockData.opsClock,
              nodeTimeZone: state.opsClockData.nodeTimeZone,
            }
          : state.opsClockData,
        breaksData: action.data.breaksData
          ? {
              opsClock: action.data.breaksData.opsClock,
              nodeTimeZone: state.breaksData.nodeTimeZone,
            }
          : state.breaksData,
      };

    case "SHOW_UPDATE_PLAN_RESPONSE_MODAL":
      return {
        ...state,
        showUpdatePlanResponseModal: action.modalState,
      };
    case "OPEN_DELETE_BREAK_MODAL":
      return {
        ...state,
        deleteBreakData: {
          openDeleteBreakModal: true,
          indexOfTheBreakToDelete: action.data,
        },
      };
    case "UPDATE_DELETE_BREAK_DATA":
      return {
        ...state,
        deleteBreakData: {
          openDeleteBreakModal: false,
          indexOfTheBreakToDelete: null,
        },
      };
    case "FETCH_RESET_TIME":
      fetchSettingsInsight(action.data.dispatcher);
      return state;
    case "UPDATE_RESET_TIME":
      return {
        ...state,
        resetTime: {
          ...action.data,
        },
      };
    case "ADD_ERROR":
      return {
        ...state,
        opsClockErrors: [...state.opsClockErrors, action.payload],
      };
    case "ADD_DIRTY_PAIR":
      if (state.opsClockDirtyPairs.includes(action.payload)) {
        return {
          ...state,
          opsClockDirtyPairs: [
            ...state.opsClockDirtyPairs.filter((a) => a !== action.payload),
          ],
        };
      } else {
        return {
          ...state,
          opsClockDirtyPairs: [...state.opsClockDirtyPairs, action.payload],
        };
      }
    case "CLEAR_ERROR":
      return {
        ...state,
        opsClockErrors: [
          ...state.opsClockErrors.filter((a) => a !== action.payload),
        ],
      };
    case "UPDATE_ROSTER":
      return {
        ...state,
        settingsData: {
          ...state.settingsData,
          roster: {
            ...action.data.roster,
          },
          showUpdatePlanResponseModal: action.data.showUpdatePlanResponseModal,
          messageToDisplay: action.data.messageToDisplay,
        },
      };
    case "UPDATE_SCHEDULE":
      return {
        ...state,
        settingsData: {
          ...state.settingsData,
          schedule: {
            ...action.data.schedule,
          },
          showUpdatePlanResponseModal: action.data.showUpdatePlanResponseModal,
          messageToDisplay: action.data.messageToDisplay,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/SettingsReducer.js